import { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import CustomForm from '../../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../../config/config';
import Fetch from "../../../../core/util/core/Fetch";
import { chooseProfileFilter } from "../../../helpers/chooseProfileFilter";
import { useBasePath } from "../../../../core/util/core/Path";
import sleep from "sleep-promise";

function Form() {
    const [formContent, setFormContent] = useState(<>Carregando...</>);
    const { id } = useParams();
    const navigate = useNavigate();
    const basePath = useBasePath();

    const profileFilter = chooseProfileFilter();

    const hiddenValues = {}

    if (profileFilter.pdc_entity_id) {
        hiddenValues.pdc_entity_id = profileFilter.pdc_entity_id
    }

    if (profileFilter.pdc_company_id) {
        hiddenValues.pdc_company_id = profileFilter.pdc_company_id
    }

    const path = '/behavioralcompetencies/';
    const paths = {
        endpointSave: config.endpoints.backend + 'behavioralcompetencies/save',
        endpointGetById: config.endpoints.backend + 'behavioralcompetencies/getById',
        endpointGetAllCompanies: config.endpoints.backend + 'companies/getall',
        endpointGetAllEntities: config.endpoints.backend + 'entities/getall',
        urlGoBack: path + 'list',
        pathView: path + 'view'
    }

    const labels = {
        labelTitleAdd: "Nova Competência Comportamental",
        labelTitleEdit: "Editar Competência Comportamental",
        labelTitleView: 'Visualizar Competência Comportamental'
    }

    const getForm = (values) => {
        let form = {
            validateOnChange: true,
            hiddenValues: {
                ...hiddenValues
            },
            fields: [
                !hiddenValues.pdc_company_id && !hiddenValues.pdc_entity_id && !profileFilter.pdc_project_ids ? {
                    name: 'pdc_company_id',
                    type: 'select',
                    label: 'Empresa',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllCompanies,
                        label: 'corporate_name',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter
                            }
                        }
                    },
                    handleChange: async (element, field, values) => {
                        let form = getForm(values);
                        values.pdc_entity_id = '';
                        setFormContent(<></>);
                        await sleep(1);
                        setFormContent(
                            <CustomFormContainer
                                form={form}
                                content={<CustomForm form={form} />}
                            />
                        )
                    },
                    validations: {
                        required: false
                    },
                    columnSize: 12,
                } : {},
                !hiddenValues.pdc_entity_id && !profileFilter.pdc_project_ids ? {
                    name: 'pdc_entity_id',
                    type: 'select',
                    label: 'Entidade',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllEntities,
                        label: 'corporate_name',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter,
                                pdc_company_id: !!values.pdc_company_id ? values.pdc_company_id : !!profileFilter.pdc_company_id ? profileFilter.pdc_company_id : null
                            }
                        }
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12,
                } : {},
                {
                    name: 'name',
                    type: 'text',
                    label: 'Nome da Competência',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'status',
                    type: 'radioGroup',
                    options: [
                        { label: 'Ativo', value: '1', selected: true },
                        { label: 'Inativo', value: '0' }
                    ],
                    label: 'Status',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                }
            ],
            ...paths,
            ...labels
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        if (profileFilter.pdc_project_ids && basePath !== paths.pathView) {
            navigate(paths.urlGoBack);
            return;
        }

        const load = async () => {
            let values = { status: '1' };

            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
            }

            const form = getForm(values);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />}
                />
            )
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
